<template>
  <div class="">
    <div v-if="!profile || !profile.active"
         class="pad">
      <p class='club-lead'>
        A szolgáltatással
        <ul>
          <li>Látod és jelentkezhetsz más felhasználó játékostárs keresésére</li>
          <li>Jelezheted az oldal látogatóinak, hogy játékostársat keresel</li>
          <li>A jelentkezők közül kiválaszthatod, kivel játszanál</li>
        </ul>
      </p>
      <p v-if="clubInfo.partners.length">
        {{ clubInfo.partners.length }} elérhető partner
      </p>
      <button class="ui positive button"
              @click="openProfile()">
        Csatlakozom a Club-hoz...
      </button>
    </div>
    <div v-else>
      <!--<span
        v-if="clubInfo.own.accepted"
        style="font-weight: bold"
        class="partners-title"
      >
        Megbeszéltél egy játékot vele:
      </span>
      <span v-else class="partners-title">Elérhető partnerek: </span>-->

      <div class="partners-container">
        <div class="partners-outer">


          <!--  ------------------------ saját ----------------------------- -->
          <div v-if="!clubInfo.own.accepted || clubInfo.own.available"
               :class="{inactive:!clubInfo.own.available}"
               class="item">
            <div class="partner">
              <b>{{ user.name }}</b><br/>
              <div class="partner-info">
                Te, <span v-if="clubInfo.own.available">Partnert keresel</span><span v-if="!clubInfo.own.available">Nem keresel partnert</span><br/>
                {{ rank_txts[profile.self_rank - 1] }}<br/> <i>"{{ tryhard_txts[profile.self_tryhard - 1] }}"</i>
                &nbsp;<a class="profile-link"
                         title="Profil szerkesztése..."
                         @click="openProfile()"><i class="edit icon"></i></a>
              </div>
            </div>
            <div class="buttons">
              <label>Keresek</label>
              <div class="switch small">
                <input
                  id="own-available"
                  v-model="clubInfo.own.available"
                  :true-value="true"
                  class="switch-input"
                  type="checkbox"
                  @click="
                    if (!clubInfo.own.available) {
                      addAvailable($event);
                    } else {
                      removeAvailable($event);
                    }
                  "
                />
                <label class="switch-paddle"
                       for="own-available">
                  <span aria-hidden="true"
                        class="switch-active">I</span>
                  <span aria-hidden="true"
                        class="switch-inactive">N</span>
                </label>
              </div>
            </div>
          </div>

          <div
            v-for="partner in clubInfo.partners.filter(
              (p) => !clubInfo.own.accepted || p.accepted
            )"
            :key="partner.id"
            :class="{
              accepted:partner.accepted,
              'apply-incoming': partner.applyIncoming,
              'apply-outgoing': partner.applyOutgoing

            }"
            class="item"
          >
            <div class="partner">

              <b>{{ partner.user.name }}</b><br/>
              <div class="partner-info">
                <span v-if="partner.applyIncoming && !partner.accepted">Jelentkezett partnernek!<br/></span>
                <span v-if="partner.applyOutgoing && !partner.accepted">Jelentkeztél partnernek!<br/></span>
                <span v-if="partner.accepted">Megbeszéltetek egy játékot!<br/></span>
                <span v-if="!partner.accepted && !partner.applyIncoming && !partner.applyOutgoing">Partnert keres<br/></span>


                {{ rank_txts[partner.user.self_rank - 1] }}<br/>
                <i>"{{ tryhard_txts[partner.user.self_tryhard - 1] }}"</i>
              </div>

              <div v-if="partner.partnerReserved"
                   style="font-style: italic">
                {{ partner.user.name }} foglalt már pályát!
              </div>
              <div
                v-if="partner.applyIncoming && !partner.reserved"
                class="warning"
              >
                MÉG NEM FOGLALTÁL PÁLYÁT!
              </div>
              <div
                v-if="partner.applyOutgoing && !partner.reserved"
                class="warning"
              >
                {{ partner.user.name }} még nem foglalt pályát!
              </div>


              <div style="font-size: 10px; display: none">
                i:{{ partner.applyIncoming }}&nbsp;o:{{
                  partner.applyOutgoing
                }}&nbsp;a:{{ partner.available }}<br/>
                aa: {{ partner.accepted }}
              </div>
            </div>


            <div class="buttons">

              <button
                v-if="
                  partner.available &&
                  !partner.applyOutgoing &&
                  !partner.applyIncoming
                "
                :class="{ loading: partner.loading }"
                class="ui basic positive button mini"
                @click="apply(partner)"
              >
                Jelentkezem
              </button>


              <div v-if="!partner.accepted && partner.applyOutgoing"
                   class='status outgoing'><i class='icon comments outline'></i></div>
              <button
                v-if="!partner.accepted && partner.applyOutgoing"
                :class="{ loading: partner.loading }"
                class="ui basic button mini"
                @click="removeOutgoingApply(partner)"
              >
                Visszavonom a jelentkezést
              </button>

              <div v-if="!partner.accepted && partner.applyIncoming"
                   class='status incoming'><i class='icon comments  outline'></i></div>
              <button
                v-if="!partner.accepted && partner.applyIncoming"
                :class="{ loading: partner.loading }"
                class="ui basic positive button mini"
                @click="accept(partner)"
              >
                Elfogadom a jelentkezését
              </button>


              <div v-if="partner.accepted"
                   class='status accepted'><i class='icon check calendar outline'></i></div>
              <button v-if="partner.accepted"
                      :class="{ loading: partner.loading }"
                      class="ui basic button mini"
                      @click="removeAccepted(partner)">
                Lemondom
              </button>
            </div>
          </div>

          <div v-if="!clubInfo.partners.length"
               class='partners-more'>Jelenleg nincs elérhető partner
          </div>
          <div v-if="clubInfo.own.accepted && clubInfo.own.partnerCount"
               class='partners-more'>Még {{ clubInfo.own.partnerCount }} játékos keres partnert.
          </div>
          <div v-if="clubInfo.own.accepted && !clubInfo.own.partnerCount"
               class='partners-more'>Más játékos most nem keres partnert.
          </div>
        </div>

      </div>
    </div>


    <div class="pad">
      <a v-if="profile && profile.active"
         class="profile-link"
         @click="openProfile()">Klub profilom...</a>
      <br v-else/>
    </div>
  </div>
</template>
<script>
import notify from '../../notify';
import {mapState} from 'vuex';
import {doAcceptApply, doAddAvailable, doApplyFor, doRemoveApply, doRemoveAvailable} from '@/store/partnerFinder';
import {MODAL as PROFILE_MODAL} from './PartnerFinderProfileModal';
import utils from '@/utils';
import config from '@/config';
import {doRemoveAccepted} from '../../store/partnerFinder';
//import { doRemoveAccepted } from '../../store/partnerFinder';

export default {
  props: ['clubInfo', 'subject_id', 'from_time', 'reserveExtra'],
  data () {
    return {
      /*incoming: [],
      outgoing: []*/
    };
  }, //data
  computed: {
    ...mapState({
      user: (state) => state.user,
      profile: (state) => {
        // console.log('-----profile----', state.currentClientDomain + '__' + state.currentSubjectTypeID)
        return state.partnerFinder.userProfiles[state.currentClientDomain + '__' + state.currentSubjectTypeID]
      },
      rank_txts: (state) => state.trans.partnerFinderProfileModal.rank_values,
      tryhard_txts: (state) => state.trans.partnerFinderProfileModal.tryhard_values,
    }),
  },
  components: {},
  methods: {
    openProfile () {
      this.$modal.show(PROFILE_MODAL);
    },
    addAvailable (e) {
      e.preventDefault();
      this.$store
        .dispatch(doAddAvailable, {
          subject_id: this.subject_id,
          from_time: this.from_time,
        })
        .then(() => {
          //this.$modal.hide('new-reservation-modal');
        });
    },
    removeAvailable (e) {
      e.preventDefault();
      this.$store
        .dispatch(doRemoveAvailable, {
          subject_id: this.subject_id,
          from_time: this.from_time,
        })
        .then(() => {
          //this.$modal.hide('new-reservation-modal');
        });
    },
    apply (partner) {
      let data = {
        user_id: partner.user.id,
        from_time: this.from_time,
        subject_id: this.subject_id,
      };
      this.$store.dispatch(doApplyFor, data).then((response) => {
        notify.success(response.body.msg);
      });
    },
    removeOutgoingApply (partner) {
      this.$store
        .dispatch(doRemoveApply, { id: partner.outgoingApplyId })
        .then((response) => {
          notify.success(response.body.msg);
        });
    },
    accept (partner) {
      let data = {
        accepted_partner_apply_id: partner.incomingApplyId,
      };
      this.$store.dispatch(doAcceptApply, data).then((response) => {
        notify.success(response.body.msg);
      });
    },
    removeAccepted (partner) {
      //let self = this;
      this.$http({
        url: config.SERVER_DOMAIN + '/api/guest/partner-finder/accepted-resign-check',
        method: 'GET',
        params: {
          ...this.$store.getters.getAuthParams
          , apply_id: partner.incomingApplyId || partner.outgoingApplyId,
        },
      }).then(
        (response) => {
          let msg = 'Biztosan lemondod?';

          if (response.body.willBeCharged)
            msg = response.body.msg;
          notify.confirmation(msg)
            .then(() => {
                resign();
              },
              () => {
              },
            );
        },
        (error) => {
          utils.httpError(error);
        });

      let resign = () => {
        let data = {
          apply_id: partner.incomingApplyId || partner.outgoingApplyId,
        };
        this.$store.dispatch(doRemoveAccepted, data).then((response) => {
          notify.success(response.body.msg);
        });
      } // resign()

      /*notify.confirmation("Biztosan lemondod?")
      .then(()=> {
        let data = {
          apply_id: partner.incomingApplyId || partner.outgoingApplyId
        };
        this.$store.dispatch(doRemoveAccepted, data).then((response) => {
          notify.success(response.body.msg);
        });
      });*/

    }, //removeAccepted
  }, // methods
};
</script>
<style scoped>
.pf-container {
  width: 340px;
}

.partners-title {
  text-align: left;
  display: inline-block;
  padding: 5px;
  color: #222;
}

.partners-container {
  padding: 4px 2px;
  /*border-top: 1px solid #ccc;
  border-bottom: 1px solid #e0e0e0;*/
}

.partners-outer {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-height: 320px;
  min-height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 7px;
}

.partners-outer,
.partners-container {
  background-color: #eaeaea;
}

.item {
  flex: 0 0 auto;
  background-color: #fff;
  padding: 7px;
  margin: 3px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  text-align: left;
  align-items: center;
  overflow: hidden;
  box-shadow: 0px 1px 2px #00000061;
  border-radius: 3px;
  border-left: 3px solid transparent;
  border-color: white;
}

.partner {
  flex: 1 0 190px;
}

.partner-info {
  font-size: .8em;
}

.buttons {
  flex: auto;
}

a.profile-link {
  font-size: 0.75rem;
  color: #757575;
  cursor: pointer;
}

a.profile-link:hover {
  color: #333;
  text-decoration: underline;
}

.warning {
  color: #b90f0f;
  font-size: 0.8em;
  background-color: #ffcaca57;
  margin: 2px 9px 2px 0;
  padding: 1px 1em;
  border-radius: 4px;
  font-weight: bold;
}

.partners-more {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #989898;
  text-shadow: 1px 1px #fff;
}

.item.inactive {
  color: #848484;
  background-color: #f7f7f7;
}


.item.apply-outgoing {
  border-color: orange;
}

.item.apply-incoming {
  border-color: yellowgreen;
}

.item.accepted {
  border-color: green;
}

.buttons .status {
  font-size: 48px;
  text-align: center;
  padding-bottom: 0px;
  font-weight: normal;
}

.buttons .status.outgoing {
  color: orange;
}

.buttons .status.incoming {
  color: yellowgreen;
}

.buttons .status.accepted {
  color: green;
}


/* ---------------- mini ------------------------- */
.own-avail-outer {
  display: flex;
}

.switch {
  flex: 0 0 100px;
}

.club-lead {
  text-align: left;
  padding: 1em;
}
</style>
